module.exports = __webpack_public_path__ + "img/icon_right1.a7d9745a.png";